import Button, {ButtonProps} from "@mui/material/Button";
import * as React from "react";
import {useMemo} from "react";
import PopupState, {bindMenu, bindTrigger} from "material-ui-popup-state";
import {ListItemIcon, ListItemText, Menu, MenuItem} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import {useTheme} from "../../Providers/Theme";
import {faSun} from "@fortawesome/free-solid-svg-icons/faSun";
import {faMoon} from "@fortawesome/free-solid-svg-icons/faMoon";
import {Locale} from "Providers/LocaleProvider";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAdjust} from "@fortawesome/free-solid-svg-icons/faAdjust";
import {faUserCircle} from "@fortawesome/free-solid-svg-icons/faUserCircle";
import {Profile} from "hooks/Api/useLoggedinProfile";
import {faSignOutAlt} from "@fortawesome/free-solid-svg-icons/faSignOutAlt";
import Box from "@mui/material/Box";


type Props<T extends React.ElementType> = {
    profile?: Profile.RootObject;
    logout: () => any
} & ButtonProps<T>

export const ProfileButton =
    <T extends React.ElementType, >
    ({
         profile,
         logout,
         ...props
     }: Props<T>) => {


        if (!profile) {
            return <></>
        }

        return <>
            <PopupState variant="popover">
                {(popupState) => (
                    <React.Fragment>
                        <Button
                            color="inherit"
                            size={"large"}
                            sx={{gap: "5px"}}
                            {...bindTrigger(popupState)}
                            {...props}
                        >
                            <FontAwesomeIcon fontSize={"1.5em"} icon={faUserCircle}/>
                            <Box display={"none"} sx={{display: {xs: 'none', md: 'inline-block'}}}>{profile.name}</Box>
                        </Button>
                        <Menu {...bindMenu(popupState)}
                              variant={"selectedMenu"}
                              anchorOrigin={{
                                  vertical: 'bottom',
                                  horizontal: 'left',
                              }}
                              transformOrigin={{
                                  vertical: 'top',
                                  horizontal: 'right',
                              }}>
                            <MenuItem onClick={logout}>
                                <ListItemIcon><FontAwesomeIcon icon={faSignOutAlt}/></ListItemIcon>
                                <ListItemText><Locale>auth.logout</Locale></ListItemText>
                            </MenuItem>
                        </Menu>
                    </React.Fragment>
                )}
            </PopupState>
        </>
    }
